import { Component, Prop } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import BookingForm from '@bookings/components/booking-form/booking-form.vue';
import BookingDrawerForm from '@bookings/components/drawer-booking-form/drawer-booking-form.vue';

@Component({
  name: 'bpc-display-field-link',
  components: {
    'bpc-drawer-modal': BpcDrawerModal,
    'bpc-std-form': StdForm,
    'bpc-booking-form': BookingForm,
    'bpc-drawer-booking-form': BookingDrawerForm,
  },
})
export default class DisplayFieldLink extends mixins(AbstractDisplayField) {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  public entity: any = null;

  public showForm: boolean = false;
  public showDrawerSection: boolean = false;

  public isSavingForm = false;

  public disabledForm = true; // For read only mode when click in code column
  public permissionEntityNameToUse = '';

  get size(): string {
    return this.fieldConfig?.drawerSize || 'md';
  }

  public onSavingEntity(val) {
    this.isSavingForm = val;
  }

  get showDataHoverIcon() {
    return this.fieldConfig.dataHoverIcon
      ? Object.keys(this.fieldConfig.dataHoverIcon).length > 0
      : false;
  }

  get hoverIcon() {
    const data = this.fieldConfig.dataHoverIcon;
    return data['icon'];
  }

  get hoverData() {
    const data = this.fieldConfig.dataHoverIcon;
    return this.item[this.fieldConfig.entityLink][data['data']];
  }

  get linkUrl() {
    let link = this.fieldConfig.entityLink;
    const entity = this.item[this.fieldConfig.entity];
    if (link.includes(':id')) {
      link = link.replace(':id', entity.id);
    } else if (link.includes(':alias')) {
      link = link.replace(':alias', entity.alias);
    }
    return link;
  }

  clickOnLink() {
    this.entity = this.item[this.fieldConfig.entityLink];
    this.showForm = true;
    this.showDrawerSection = true;
    this.disabledForm = true;
  }
  onFormSave() {
    this.isSavingForm = true;
    console.log('Saving');
    this.$refs.stdForm.saveEntity();
  }

  onFormSaved($event: any = null) {
    this.onFormClose();
    this.$emit('entity-saved');
  }

  onFormClose() {
    this.showForm = false;
    this.showDrawerSection = false;
  }

  get entityName(): string {
    return this.fieldConfig?.entity || this.fieldConfig.entityLink;
  }

  get formComponentName(): string {
    switch (this.fieldConfig.entityLink) {
      default:
        // return `bpc-${this.fieldConfig.inputType}`;
        return 'bpc-std-form';
    }
  }

  /**
   * ONLY FOR BOOKING
   */
  get drawerBookingStoreName() {
    return this.entity ? `booking_${this.entity.id}` : 'booking';
  }

  get bookingDrawerTitle(): string {
    return this.$t('global.modals.edit') + ' ' + this.$t('global.models.booking.name');
  }

  onFormEdit() {
    this.disabledForm = false;
  }

  getModalTitle() {
    if (this.disabledForm) {
      const title = this.$t('global.models.' + this.entityName + '.name').toString();
      return title.charAt(0).toUpperCase() + title.slice(1); // capitalize
    } else if (this.entity && this.entity.id) {
      return (
        this.$t('global.modals.edit') + ' ' + this.$t('global.models.' + this.entityName + '.name')
      );
    } else {
      return (
        this.$t('global.modals.create') +
        ' ' +
        this.$t('global.models.' + this.entityName + '.name')
      );
    }
  }
}
